import { Routes, Route } from "react-router-dom";
import ResendBooking from "./ResendBooking";
import ReconfirmConfirmation from "./ReconfirmConfirmation";

const Reconfirm = () => {
  return (
    <>
      <div className="form-layout__main">
        <Routes>
          <Route
            path="resendtime"
            element={
              <>
                <ResendBooking />
              </>
            }
          />
          <Route
            path="resendbekreftelse"
            element={
              <>
                <ReconfirmConfirmation />
              </>
            }
          />
        </Routes>
      </div>
    </>
  );
};

export default Reconfirm;
